const SEARCH_HISTORY_IDENTITY = "ML_SEARCH_HISTORY";

export function setItem(historyItem) {
  try {
    const historyJson = localStorage.getItem(SEARCH_HISTORY_IDENTITY);
    let history = historyJson === null ? [] : JSON.parse(historyJson);
    if (!history.includes(historyItem)) {
      history.unshift(historyItem);
      localStorage.setItem(SEARCH_HISTORY_IDENTITY, JSON.stringify(history));
    }
  } catch (e) {
    console.error("localStorage 存储错误", e);
  }
}
export function getAll() {
  const result = localStorage.getItem(SEARCH_HISTORY_IDENTITY);
  return result ? JSON.parse(result) : [];
}
export function clear() {
  localStorage.removeItem(SEARCH_HISTORY_IDENTITY);
}
